import React from "react";
import "./List.scss";

// Services
import { ApiService } from "../../services";

// Context

// Components
import { IonCard, IonCol, IonContent, IonRefresher, IonRefresherContent, IonRow } from "@ionic/react";
import { useQuery } from "@tanstack/react-query";
import { t } from "i18next";
import NewsItem from "../../components/NewsItem";
import { PageHeader } from "../../components/PageHeader";
import BasicTemplate from "../../components/PageTemplates/BasicTemplate";
import { useViewport } from "../../utils/useViewport";
import CardSkeleton from "./CardSkeleton";
import { CategoryFilter } from "./CategoryFilter";

export const List = (props: any) => {
  const [categoryId, setCategoryId] = React.useState<number>(0);
  const { isLoading, data, refetch } = useQuery({
    queryKey: ["news", "index", categoryId],
    queryFn: (context) => {
      return ApiService.get("news?categoryId=" + categoryId);
    },
  });
  const { isMobile } = useViewport();

  return (
    <BasicTemplate className="page--news-list" hideHeader={isMobile} title={t("latest") || ""}>
      <IonContent className={"ion-padding"} fullscreen={true}>
        <IonRefresher slot="fixed" onIonRefresh={(e) => refetch().then(() => e.detail.complete())}>
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>

        <PageHeader>{t("latest")}</PageHeader>
        <CategoryFilter
          onFilterChange={(categoryId: number) => {
            setCategoryId(categoryId);
          }}
        />

        <IonRow className="news-list__content">
          {isLoading ? (
            /* 3 skeletons for loading state */
            <>
              {[...Array(3)].map((e, i) => (
                <IonCol size="12" key={i}>
                  <IonCard className="card card--skeleton card--news-item news-item">
                    <CardSkeleton imageHeight="180px" excerptOnly={true} />
                  </IonCard>
                </IonCol>
              ))}
            </>
          ) : data.data?.length ? (
            data.data.map((article: any, key: number) => (
              <IonCol size={"12"} sizeMd={"4"} sizeXl={"3"} key={"article-" + key}>
                <NewsItem item={article} />
              </IonCol>
            ))
          ) : (
            <IonCol size="12">
              <p>{t("noArticles")}</p>
            </IonCol>
          )}
        </IonRow>
      </IonContent>
    </BasicTemplate>
  );
};
